import React, { Component } from "react";
import { connect } from "react-redux";

import store from "../../store/store";

import Button from '@material-ui/core/Button';
import 'typeface-roboto';
import Typography from '@material-ui/core/Typography';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import FastForwardIcon from '@material-ui/icons/FastForward';
import IconButton from '@material-ui/core/IconButton';
import Session from "../../containers/Session/Session";


import "./Main.css";

import session1 from '../../files/session1.json';

const sessions = [session1];

class Main extends Component {

    constructor(props, context) {
		super(props, context);
		this.state = {
            
        };
        
	}
    componentDidMount() {
   }

	render() {

		return (
            sessions.map((session) =>
                <React.Fragment>
                    <Session session={session}/>
			    </React.Fragment>
            )
		);
	}
}

const mapStateToProps = state => {
	return {
	};
};

export default connect(mapStateToProps)(Main);
